import styled from '@emotion/styled'

import { PushIcon } from '@arcade/web/icons/react'
import { Flex } from '@cash-design-system/react'
import {
  CellDefaultCellDefaultAccessoryLabeledPush,
  CellDefaultCellDefaultAccessoryLeadingImage,
} from '@cash-web/protos/squareup/cash/ui/arcade/elements/CellDefault.pb'
import logger from '@cash-web/shared/util-logger'
import { useColorProtoAdapter } from '@cash-web/shared-proto-adapters-ui-color'

import { ArcadeCellLabelAccessoryWrapper } from '../ArcadeCellLabelAccessoryWrapper/ArcadeCellLabelAccessoryWrapper'

// ArcadeIconProps has no style/className passthrough, so the spacer's hiding lives on a wrapper.
const HiddenChevronSpacer = styled.span`
  display: inline-flex;
  visibility: hidden;
`

const PushIconLabel = styled.span<{ disabled: boolean; colorOverride?: string }>`
  ${({ theme }) => theme.typography.body};
  white-space: nowrap;
  color: ${({ theme, disabled, colorOverride }) => {
    if (colorOverride) {
      return colorOverride
    } else {
      return disabled ? theme.arcadeColors.component.cellLabelDisabled : theme.arcadeColors.component.cellLabelDefault
    }
  }};
`

export function ArcadeAccessoryLabeledPushFromProto({
  protoProps,
  accessoryLeadingImage,
  collapseHiddenChevronSpace = false,
  disabled = false,
}: {
  protoProps: CellDefaultCellDefaultAccessoryLabeledPush
  accessoryLeadingImage?: CellDefaultCellDefaultAccessoryLeadingImage
  // Defaults to reserving a hidden chevron's slot so labels stay aligned across rows.
  collapseHiddenChevronSpace?: boolean
  disabled?: boolean
}) {
  const { getColorValue } = useColorProtoAdapter()

  if (protoProps?.vertical_alignment) {
    logger.warn(new Error('ArcadeCellAccessoryFromProto: vertical_alignment not currently supported'))
  }

  const labelColor = getColorValue(protoProps.text_color)

  return (
    <ArcadeCellLabelAccessoryWrapper accessoryLeadingImage={accessoryLeadingImage}>
      <Flex>
        <PushIconLabel disabled={disabled} colorOverride={labelColor}>
          {protoProps.text?.translated_value}
        </PushIconLabel>
        {protoProps.hide_push_chevron ? (
          !collapseHiddenChevronSpace && (
            <HiddenChevronSpacer data-testid="hidden-chevron-spacer">
              <PushIcon variant="standard" />
            </HiddenChevronSpacer>
          )
        ) : (
          <PushIcon variant={disabled ? 'disabled' : 'standard'} data-testid="labeled-push-icon" />
        )}
      </Flex>
    </ArcadeCellLabelAccessoryWrapper>
  )
}
